Vue.component('checkout-country-select', {

    delimiters: ['${', '}'],

    props: [
        'countryList',
        'selectedCountryId',
        'selectedStateId',
        'template',
        'addressType'
    ],

    data() {
        return {
            stateList: [],
            selectedCountry: {}
        };
    },

    computed: Vuex.mapState({
        shippingCountryId: state => state.localization.shippingCountryId
    }),

    watch: {
        selectedCountryId() {
            this.updateSelectedCountry();
        }
    },

    created() {

        this.$options.template = this.template;

        this.sortCountries(this.countryList);
        this.updateSelectedCountry();
    },

    methods: {

        countryChanged(value) {
            this.$emit('country-changed', this.getCountryById(parseInt(value)));
            this.$emit('state-changed', null);
        },
        stateChanged(value) {
            this.$emit('state-changed', parseInt(value));
        },
        getCountryById(countryId) {

            return this.countryList.find(
                function (country) {

                    if (country.id === countryId) {
                        return country;
                    }

                    return null;
                }
            );
        },
        updateSelectedCountry() {

            const countryId = this.selectedCountryId || this.shippingCountryId;

            this.selectedCountry = this.getCountryById(countryId);

            if (this.selectedCountry) {
                this.stateList = this.parseShippingStates(this.countryList, countryId);
            }

            this.countryChanged(countryId);
        },
        parseShippingCountries(countryList, id) {

            let deliveryCountries = [];

            if (countryList === null) {
                return deliveryCountries;
            }

            for (let key in countryList) {

                let country = countryList[key];
                let option  = {id: country.id, name: country.name, locale: country.isoCode2, selected: false};

                option.selected = (id === country.id);
                deliveryCountries.push(option);
            }

            return deliveryCountries;
        },
        sortCountries(countries) {
            countries.sort(function (first, second) {
                if (first.name < second.name) {
                    return -1;
                }
                if (first.name > second.name) {
                    return 1;
                }
                return 0;
            });
        },
        parseShippingStates(countryList, countryID) {

            let states = [];

            for (let key in countryList) {

                let country = countryList[key];

                if (country.id === countryID) {
                    states = country.states;
                    break;
                }
            }

            return states;
        }
    }
});
